import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getDocumentNamespaces = (callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_DOCUMENT_NAMESPACES' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/mfnt/rag/namespaces`, {
            params: {
              requestId: reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_DOCUMENT_NAMESPACES_DONE',
              payload: {
                response: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_DOCUMENT_NAMESPACES_FAILED',
              payload: `Failed to get document namespaces`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_DOCUMENT_NAMESPACES_FAILED',
            payload: `Failed to get document namespaces`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_DOCUMENT_NAMESPACES_FAILED',
        payload: `Failed to get document namespaces`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default getDocumentNamespaces;
